import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  ListMediaByIdsCommand,
  type ListMediaByIdsCommandInput,
  type ListMediaByIdsCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient, withRetry } from '../../../shared/data';
import { MEDIA_URL_REFRESH_INTERVAL_MS } from '../../../shared/data/media';

const MEDIA_BY_IDS_KEY = 'media-by-ids';

/**
 * Query hook for resolving media IDs into presigned-URL MediaResponse
 * objects. Used by the attachment display to render thumbnails for
 * already-persisted evidence.
 *
 * The SDK caps at 20 IDs per call.
 *
 * Refetches on `MEDIA_URL_REFRESH_INTERVAL_MS` so the presigned URLs
 * embedded in the response stay ahead of their server-side TTL — a
 * user parked on the same question for longer than the URL expiry
 * would otherwise see 403 images because the mutation path never
 * touches this cache and the audit-summary poll only carries media
 * IDs (never URLs). `refetchIntervalInBackground: false` keeps
 * hidden tabs quiet; on focus regain the default
 * `refetchOnWindowFocus: true` picks up a fresh URL anyway.
 */
export const useListMediaByIdsQuery = createQuery<
  ListMediaByIdsCommandInput,
  ListMediaByIdsCommandOutput
>(
  MEDIA_BY_IDS_KEY,
  (input: ListMediaByIdsCommandInput) =>
    withRetry(() => apiHeliosClient.send(new ListMediaByIdsCommand(input))),
  {
    refetchInterval: MEDIA_URL_REFRESH_INTERVAL_MS,
    refetchIntervalInBackground: false,
  },
);
